import React, { useMemo } from 'react';

const FlowChartTerminalDock = ({
  isOpen,
  onToggle,
  lines,
  onSubmit,
  onClear,
  statusLabel = 'Disconnected',
  isBusy = false,
  inputValue = '',
  onInputChange,
}) => {
  if (!isOpen) {
    return null;
  }

  const resolvedLines = useMemo(() => {
    if (Array.isArray(lines) && lines.length > 0) {
      return lines;
    }
    return [
      { id: 'ready', type: 'system', text: '$ ready' },
      { id: 'hint', type: 'muted', text: '# AI terminal hazır' },
    ];
  }, [lines]);

  return (
    <div
      style={{
        background: '#0f1117',
        borderTop: '1px solid #2a2a2a',
        height: 240,
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Menlo, Monaco, "Courier New", monospace',
      }}
    >
      <div
        style={{
          height: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 12px',
          background: '#151820',
          borderBottom: '1px solid #2a2a2a',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ color: '#d1d5db', fontSize: 12 }}>Terminal</span>
          <span
            style={{
              fontSize: 10,
              color: statusLabel === 'Connected' ? '#86efac' : '#9ca3af',
              border: `1px solid ${statusLabel === 'Connected' ? '#14532d' : '#374151'}`,
              padding: '1px 6px',
              borderRadius: 999,
            }}
          >
            {statusLabel}
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <button
            onClick={onClear}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#9ca3af',
              cursor: 'pointer',
              padding: '2px 6px',
              fontSize: 12,
            }}
            title="Clear"
          >
            ⟲
          </button>
          <button
            onClick={onToggle}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#9ca3af',
              cursor: 'pointer',
              padding: '2px 6px',
              fontSize: 12,
            }}
            title="Minimize"
          >
            _
          </button>
        </div>
      </div>
      <div
        style={{
          flex: 1,
          padding: '12px',
          color: '#d1d5db',
          fontSize: 12,
          overflow: 'auto',
          lineHeight: 1.5,
        }}
      >
        {resolvedLines.map((line) => {
          const color = line.type === 'error'
            ? '#f87171'
            : line.type === 'ai'
              ? '#86efac'
              : line.type === 'user'
                ? '#60a5fa'
                : line.type === 'muted'
                  ? '#6b7280'
                  : '#d1d5db';
          return (
            <div key={line.id} style={{ color }}>
              {line.text}
            </div>
          );
        })}
      </div>
      <div
        style={{
          display: 'flex',
          gap: 8,
          padding: '8px 12px',
          borderTop: '1px solid #2a2a2a',
          background: '#0f1117',
        }}
      >
        <input
          value={inputValue}
          onChange={(e) => onInputChange?.(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              onSubmit?.();
            }
          }}
          placeholder="Şeklin scripti için isteğini yaz..."
          disabled={isBusy}
          style={{
            flex: 1,
            background: '#0b0d12',
            border: '1px solid #2a2a2a',
            color: '#e5e7eb',
            borderRadius: 6,
            padding: '8px 10px',
            fontSize: 12,
            outline: 'none',
          }}
        />
        <button
          onClick={onSubmit}
          disabled={isBusy}
          style={{
            background: isBusy ? '#1f2937' : '#2563eb',
            border: 'none',
            color: isBusy ? '#9ca3af' : 'white',
            padding: '8px 12px',
            borderRadius: 6,
            fontSize: 12,
            cursor: isBusy ? 'not-allowed' : 'pointer',
            fontWeight: 600,
          }}
        >
          {isBusy ? 'Çalışıyor…' : 'Gönder'}
        </button>
      </div>
    </div>
  );
};

export default FlowChartTerminalDock;
